namespace GeniuzPOS.PriceChange {
    export interface ApprovePriceChangeForm {
        ApproveFg: Serenity.EnumEditor;
        PluCode: Serenity.LookupEditor;
        EffectiveDate: Serenity.DateEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
    }

    export class ApprovePriceChangeForm extends Serenity.PrefixedContext {
        static formKey = 'PriceChange.ApprovePriceChange';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApprovePriceChangeForm.init)  {
                ApprovePriceChangeForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ApprovePriceChangeForm, [
                    'ApproveFg', w0,
                    'PluCode', w1,
                    'EffectiveDate', w2,
                    'SellUnitPrice1', w3,
                    'SellUnitPrice2', w3,
                    'SellUnitPrice3', w3,
                    'SellUnitPrice4', w3,
                    'SellUnitPrice5', w3,
                    'SellUnitPrice6', w3
                ]);
            }
        }
    }
}
